export const DT = {
  // Fuente principal para títulos y elementos destacados: griega, táctica, nítida
  greek: "'Orbitron', 'Chakra Petch', sans-serif",
  // Fuente para decretos y textos solemnes: nítida con buena legibilidad
  decree: "'Rajdhani', 'Chakra Petch', sans-serif",
  // Fuente para textos en latín o citas: limpia y con personalidad
  latin: "'Rajdhani', sans-serif",
  // Fuente para terminales y datos técnicos: monoespaciada, nítida
  terminal: "'Share Tech Mono', 'JetBrains Mono', monospace",
  // Fuente para bloques de texto extensos: alta legibilidad
  notebook: "'Rajdhani', 'Inter', sans-serif",
  // Fuente para datos pequeños y etiquetas: funcional y compacta
  data: "'Share Tech Mono', 'Chakra Petch', monospace",
};

export const DS = {
  // Escala de tamaños optimizada para legibilidad en todos los dispositivos
  hero: "clamp(1.3rem, 4vw, 2.2rem)",
  h1: "clamp(1.1rem, 3vw, 1.6rem)",
  h2: "clamp(0.9rem, 2.5vw, 1.3rem)",
  h3: "clamp(0.8rem, 2vw, 1.1rem)",
  terminal_xl: "2rem",
  terminal_lg: "1.4rem",
  terminal_md: "1rem",
  terminal_sm: "0.8rem",
  body: "0.6rem",     // Tamaño mínimo para texto corrido (>0.5rem)
  bodyLg: "0.7rem",
  bodySm: "0.55rem",  // Antes 0.44rem, ahora legible
  label: "0.55rem",   // Antes 0.44rem
  badge: "0.5rem",    // Antes 0.40rem
  micro: "0.48rem",   // Antes 0.36rem, ahora legible sin lupa
};

export const DL = {
  // Espaciado entre letras optimizado para cada tipo de texto
  decree: "0.15em",
  greek: "0.12em",
  terminal: "0.1em",
  notebook: "0.05em",
  data: "0.12em",
  micro: "0.2em",
};
